import { biLoggerFactory } from 'wix-private';
import wixLocation from 'wix-location';
const biLogger = biLoggerFactory('lp', 19, { msid: 'cea1e625-ef4a-40d7-bef8-2d50ce63a50e' });
import { getAllEvents, getZoomLink } from 'backend/dataFunctions.jsw';

$w.onReady(function () {
	initRepeaterOnItemReady();
	initRepeaterData();
});

async function initRepeaterData() {
	let events = await getAllEvents();
	if (events) {
		$w('#eventsRepeater').data = events.filter(function (event) {
			return event.status === 'SCHEDULED';
		}).sort((a, b) => a.start - b.start);
	} else {
		console.log('Did not find any items');
	}
}

async function initRepeaterOnItemReady() {
	$w('#eventsRepeater').onItemReady(async ($item, itemData, index) => {
		$item('#eventCategoryLabel').text = itemData.description;
		$item('#eventDateLabel').text = itemData.scheduleStartDateFormatted + ' at ' + itemData.scheduleStartTimeFormatted + ' EST';
		$item('#eventTitleLabel').text = itemData.title;
		$item('#eventImage').src = itemData.mainImage;
		const isRoundTable = await itemData.description.includes('ROUND TABLE');
		const isEvent = await itemData.description.includes('EVENT');
		const eventLink = await getZoomLink(itemData._id);
		if (isRoundTable) {
			$item('#eventRegisterButton').enable();
			$item('#eventRegisterButton').label = 'Register Now →';
			$item('#eventRegisterButton').onClick(() => {
				wixLocation.to(`/events-2/${itemData.slug}`);
			});
			// $item('#eventRegisterButton').link = await getZoomLink(itemData._id);
			// const roundTableLink = await getZoomLink(itemData._id);
			// console.log("roundTableLink", $item('#eventRegisterButton').link)
			// $item('#eventRegisterButton').onClick(() => {
			// 	wixLocation.to(roundTableLink)
			// });
			// } else {
		}
		if (isEvent && eventLink) {
			$item('#eventRegisterButton').enable();
			$item('#eventRegisterButton').label = 'Register Now →';
			// $item('#eventRegisterButton').link = await getZoomLink(itemData._id);
			$item('#eventRegisterButton').onClick(() => {
				wixLocation.to(eventLink)
			});
		} else if (isEvent && !eventLink) {
			$item('#eventRegisterButton').disable();
			$item('#eventRegisterButton').hide()
			$item('#registrationOpenSoon').show()
		} else {
			$item('#eventRegisterButton').enable();
			$item('#eventRegisterButton').onClick(() => {
				wixLocation.to(`/events-2/${itemData.slug}`);
			});
		}
		
	});
}

async function fireEvent(button) {
	const biEventObject = {
		evid: 703,
		button_name: button,
		is_valid: true,
		topic: 'wix partners site',
		url: wixLocation.url
	};
	await biLogger.log(biEventObject);
}

export async function joinNow_click(event) {
	await fireEvent('join now')
}

export async function resources_click(event) {
	await fireEvent('resources')
}

export async function forum_click(event) {
	await fireEvent('forum')
}

export async function blog_click(event) {
	await fireEvent('blog')
}

export async function schedule_click(event) {
	await fireEvent('schedule a call')
}

export async function bookAdemoHeader_click(event) {
	await fireEvent('book a demo')
}

export async function learnMoreLeads_click(event) {
	await fireEvent('learn more')
}

export async function joinNowRevenue_click(event) {
	await fireEvent('join now')
}

export async function joinNowAgency_click(event) {
	await fireEvent('join now')
}

export async function bookAdemoPartner_click(event) {
	await fireEvent('book a demo')
}